import React from "react";

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  componentDidCatch(error, info) {
    console.error("App error boundary caught:", error, info);
  }
  render() {
    if (this.state.hasError) {
      return (
        <div data-testid="error-fallback" className="min-h-[60vh] flex items-center justify-center bg-[#F8F9FA] px-4">
          <div className="max-w-md text-center bg-white border border-slate-200 p-8">
            <div className="font-display text-2xl text-[#29324A]">Something went wrong</div>
            <p className="text-sm text-slate-600 mt-3 leading-relaxed">
              We&apos;re sorry — this page hit an unexpected error. Your information was not lost on our side.
              Please refresh the page or return to the homepage. If it keeps happening, contact us and we&apos;ll help right away.
            </p>
            <div className="mt-6 flex items-center justify-center gap-3">
              <button
                data-testid="error-reload-btn"
                onClick={() => window.location.reload()}
                className="bg-[#29324A] hover:bg-[#1f2638] text-white text-xs font-bold tracking-wider uppercase px-5 py-3 transition-colors"
              >
                Refresh Page
              </button>
              <a
                href="/"
                data-testid="error-home-btn"
                className="bg-[#C43A89] hover:bg-[#a22b6e] text-white text-xs font-bold tracking-wider uppercase px-5 py-3 transition-colors"
              >
                Go Home
              </a>
            </div>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
